import { useParams } from 'react-router-dom';
import { DatasetCreationEnum } from '~/api/types';
import { useGetDatasetEnumsQuery } from '~/api/v2/hooks';
import { MultipleSelect, SelectOption } from '~/components';

const DimensionalityField = () => {
  const datasetId = +useParams().id!;
  const { data: dimensionalityOptions, isFetching } = useGetDatasetEnumsQuery({
    enumKey: DatasetCreationEnum.DIMENSIONALITY,
  });

  const selectOptions: SelectOption[] =
    dimensionalityOptions?.map(({ value }) => ({
      value,
      label: value.replace(/_/g, ' '),
    })) || [];

  return (
    <MultipleSelect
      name="dimensionality"
      label="DIMENSIONALITY"
      options={selectOptions}
      placeholder="Select the dimensionality"
      disabled={isFetching || !!datasetId}
    />
  );
};

export default DimensionalityField;
